/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Action_ContinueInputs */

const cs_action_continue = /** @type {(inputs: Action_ContinueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pokračovat`)
};

const en_action_continue = /** @type {(inputs: Action_ContinueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Continue`)
};

/**
* | output |
* | --- |
* | "Continue" |
*
* @param {Action_ContinueInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const action_continue = /** @type {((inputs?: Action_ContinueInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Action_ContinueInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_action_continue(inputs)
	return cs_action_continue(inputs)
});